export function camelToKebab(string) {
  return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-fullpage.js/src/helpers.js
// module id = 69
// module chunks = 0